import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import Button from 'components/Button';
import LoanBreakdown from 'components/LoanBreakdown';
import FormContainer from 'components/LoanForm/FormContainer';

import { RoutePath } from 'enums/Routes';

import { ReactComponent as CheckIcon } from 'images/check-icon-rounded.svg';

import { getApplicationData as getApplicationDataSelector } from 'selectors/getApplicationData';

import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { useNavigate } from 'hooks/useNavigate';

import { getApplicationData } from 'thunks';

import { ConversionType, trackConversion } from 'utils/analytics';

import styles from './FundsSent.module.scss';

const FundsSent = () => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const navigate = useNavigate();
  const { application } = useSelector(getApplicationDataSelector);

  useEffect(() => {
    if (application) dispatchWithUnwrap(getApplicationData(application.id));

    trackConversion(ConversionType.LoanFundsSent);
  }, []);

  return (
    <FormContainer icon={<CheckIcon />} title="Congratulations">
      {application && (
        <LoanBreakdown
          container={styles.loanBreakdownContainer}
          application={application}
          subtitle="Loan Amount"
          showFees={false}
          isFinal
        />
      )}
      <Button onClick={() => navigate(RoutePath.FinancialDashboard)}>Next</Button>
    </FormContainer>
  );
};

export default FundsSent;
